/**
 * Created by adalto on 6/3/14.
 */

Greenmile.Task = Greenmile.Task || {};
Greenmile.Task.RelatedInfo = Greenmile.Task.RelatedInfo || {};

Greenmile.Task.RelatedInfo.Event = {
    overwriteFilterEvents: function () {

        var arrayFilter = {};
        var eventLog = new App.Models.EventLog();
        var filterEventsForm = $("#taskManager-event .row");
        var divAlertError;
        var eventTypeContainer = document.querySelector('#Task #tabEventLookupEventType > label');
        const equipmentId = App.Forms.TabEventEquipmentLookup.lookupElement.getValue();
        const routeId = App.Forms.EventRouteLookup.lookupElement.getValue();
        const stopId = App.Forms.StopLookup.lookupElement.getValue();
        const eventId = App.Forms.EventLookup.lookupElement.getValue();

        if (equipmentId) {
          arrayFilter.equipment = equipmentId;
        }

        if (routeId) {
          arrayFilter.route = routeId;
        }

        if (stopId) {
          arrayFilter.stop = stopId;
        }

        if (eventId) {
          arrayFilter.event = eventId;
        }

        if (arrayFilter.event) {

            divAlertError = document.querySelector('#taskManager-event .alert-error');
            filterEventsForm.attr("filtered", "ok");
            arrayFilter.closed = false;

            eventLog.searchAllWithCriteria({
                searchJson: arrayFilter,
                criteria: Greenmile.EventLog.Util.criteria,
                success: (function (scope) {
                    return function (data) {
                        Monet.Session.Task.lastLinkForm.events.filter = [];

                        var keys = Object.keys(data.attributes), size = Monet.Session.Task.lastLinkForm.events.ids.length;

                        for (var z = 0; z < keys.length; z++) {
                            Monet.Session.Task.lastLinkForm.events.filter.push(data.attributes[keys[z]]);
                        }

                        if (size > 0) {
                            for (var i = keys.length - 1; i >= 0; i--) {

                                for (var j = 0; j < size; j++) {
                                    if (data.attributes[keys[i]].id.toString() === Monet.Session.Task.lastLinkForm.events.ids[j].value) {
                                        Monet.Session.Task.lastLinkForm.events.filter.splice(i, 1);
                                    }
                                }
                            }
                        }

                        scope.renderFilteredEventsList(Monet.Session.Task.lastLinkForm.events.filter);

                    };
                }(this))
            });

            if (divAlertError) {
                divAlertError.style.display = 'none';
            }
            eventTypeContainer.parentNode.className = '';

        } else {

            divAlertError = document.querySelector('#taskManager-event .alert-error');
            var monetMessage = new Monet.Form.Messages.InlineMessage();
            var errorObj = {
                errorMessages: []
            };

            if (!arrayFilter["event"]) {

                errorObj.errorMessages.push(
                    Monet.Form.Messages.mountErrorMessageObject('TaskManager.Event.EventTypeIsRequired'));
            }

            if (errorObj.errorMessages.length > 0) {
                monetMessage.setScope("#taskManager-event");
                monetMessage.setInfoType("error");
                monetMessage.setMessage(errorObj);
                monetMessage.triggerMessage();

                eventTypeContainer.parentNode.className = 'control-group error';

            } else {
                if (divAlertError) {
                    divAlertError.style.display = 'none';
                }
            }

            filterEventsForm.removeAttr("filtered", "ok");
        }


    },

    createFullEventInfo: function (data) {

        Monet.Session.Task.lastLinkForm.events.nodes = [];
        Monet.Session.Task.lastLinkForm.events.data = [];
        Monet.Session.Task.lastLinkForm.events.ids = [];

        for (var i = 0, l = data.length; i < l; i++) {

            if (data[i].hasOwnProperty('eventLog')) {
                this.createEventLogIdNode(data[i]);
            }

        }

    },

    createEventLogIdNode: function (data) {

        if (data && data.eventLog) {

            var divContainer = document.createElement('div');
            var GreenmileTaskRouteListLine = document.createElement('div');
            var GreenmileTaskRouteListCloumnDesc = document.createElement('div');
            var GreenmileTaskRouteListCloumnDate = document.createElement('div');
            var Destroylink = document.createElement('div');
            var input = document.createElement('input');
            var inputStatus = document.createElement('input');
            var inputLinked = document.createElement('input');
            var linkedTaskWhen = document.createElement('input');

            var formattedDate = Monet.Format.Date.formatToLocale(data.eventLog.timeValuedTrue);

            GreenmileTaskRouteListLine.className = "GreenmileTaskRouteListLine";
            GreenmileTaskRouteListLine.id = 'event_list_line_' + data.eventLog.id;

            GreenmileTaskRouteListCloumnDesc.className = "GreenmileTaskRouteListCloumn";
            GreenmileTaskRouteListCloumnDate.className = "GreenmileTaskRouteListCloumn";
            Destroylink.className = "table-action-destroylink coisa";

            linkedTaskWhen.type = 'hidden';
            linkedTaskWhen.id = 'taskLinkeds[' + data.eventLog.id + '].when';
            linkedTaskWhen.name = 'taskLinkeds[' + data.eventLog.id + '].when';
            linkedTaskWhen.className = "modelAttribute";
            linkedTaskWhen.value = data.when || Monet.Format.DateTime.formatToISOString(new Date());

            input.type = 'hidden';
            input.name = 'taskLinkeds[' + data.eventLog.id + '].eventLog.id';
            input.id = 'taskLinkeds[' + data.eventLog.id + '].eventLog.id';
            input.className = 'modelAttribute eventLogId';
            input.value = data.eventLog.id;

            inputStatus.type = 'hidden';
            inputStatus.name = 'taskLinkeds[' + data.eventLog.id + '].status';
            inputStatus.id = 'taskLinkeds[' + data.eventLog.id + '].status';
            inputStatus.className = "modelAttribute";
            inputStatus.value = '';

            inputLinked.type = 'hidden';
            inputLinked.name = 'taskLinkeds[' + data.eventLog.id + '].id';
            inputLinked.id = 'taskLinkeds[' + data.eventLog.id + '].id';
            inputLinked.className = "modelAttribute";
            inputLinked.value = data.id || '';

            Destroylink.addEventListener('click', (function (scope, data) {

                return function (e) {

                    e.preventDefault();

                    const confirmDeleteEvent = () => {
                        
                        App.Views.Task.showLoadingElement(this);
                        Greenmile.Task.RelatedInfo.deleteTaskLinked(data.id, (function (e) {
                            return function () {

                                App.Views.Task.hideLoad();

                                scope.removeLinkedEventFromList(e.target);
                                scope.removeLinkedEventFromData(e.target, scope);
                                Greenmile.Task.RelatedInfo
                                    .removeTitleContainerIfEmptyTo(
                                        Greenmile.Task.RelatedInfo.collections.EVENTS
                                    );
                            };
                        }(e)));

                    };

                    Greenmile.Task.RelatedInfo.showAlertToConfirm(confirmDeleteEvent);

                };

            }(this, data)));

            GreenmileTaskRouteListCloumnDesc.appendChild(document.createTextNode(data.eventLog.messageBody));
            GreenmileTaskRouteListCloumnDate.appendChild(document.createTextNode(formattedDate));

            GreenmileTaskRouteListLine.appendChild(GreenmileTaskRouteListCloumnDesc);
            GreenmileTaskRouteListLine.appendChild(GreenmileTaskRouteListCloumnDate);

            Destroylink.appendChild(input);
            Destroylink.appendChild(inputStatus);
            Destroylink.appendChild(inputLinked);

            divContainer.appendChild(GreenmileTaskRouteListLine);
            divContainer.appendChild(Destroylink);
            divContainer.appendChild(linkedTaskWhen);

            Monet.Session.Task.lastLinkForm.events.nodes.push(divContainer);
            Monet.Session.Task.lastLinkForm.events.data.push(data);
            Monet.Session.Task.lastLinkForm.events.ids.push(input);
        }

    },

    removeLinkedEventFromList: function (el) {

        var lineItem = el.parentNode.parentNode;

        if (lineItem.className === 'taskEventsSelected') {
            lineItem = el.parentNode;
        }

        if (lineItem.className === 'row') {
            lineItem = el.parentNode;
        }

        var lineItemContainer = lineItem.parentNode;
        lineItemContainer.removeChild(lineItem);

    },

    removeLinkedEventFromData: function (el) {

        var node = el.parentNode.lastChild;
        var nodes = Monet.Session.Task.lastLinkForm.events.nodes;
        var ids = Monet.Session.Task.lastLinkForm.events.ids;
        var data = Monet.Session.Task.lastLinkForm.events.data;
        var nodeId = null;
        var index = null;

        for (var i = 0, l = nodes.length; i < l; i++) {

            nodeId = nodes[i].lastChild.id;

            if (nodeId === node.id) {
                index = i;
            }
        }

        if (index !== null) {
            nodes.splice(index, 1);
            ids.splice(index, 1);
            data.splice(index, 1);
            delete Monet.Session.Task.newTask.events[index];
        }

    },

    renderItemToEventLogList: function (data, position) {

        var messageBody,
            timeValuedFalse,
            destroylink,
            destroyHidden,
            listLine,
            eventLine,
            routeId,
            formattedDate;

        eventLine = document.createElement('div');
        messageBody = document.createElement('div');
        timeValuedFalse = document.createElement('div');
        destroylink = document.createElement('div');
        listLine = document.createElement('div');
        destroyHidden = document.createElement('input');
        routeId = document.createElement('input');

        listLine.className = 'GreenmileTaskRouteListLine';

        messageBody.className = 'GreenmileTaskRouteListCloumn';
        timeValuedFalse.className = 'GreenmileTaskRouteListCloumn';
        destroylink.className = 'table-action-destroylink';

        destroyHidden.type = 'hidden';
        destroyHidden.value = data.id;
        destroyHidden.name = 'route[' + data.id + '].id';
        destroyHidden.className = 'modelAttribute eventLogId';

        routeId.type = 'hidden';
        routeId.value = data.id;
        routeId.name = 'route[' + data.id + '].id';
        routeId.className = 'modelAttribute';

        formattedDate = Monet.Format.Date.formatToLocale(data.timeValuedTrue);

        eventLine.setAttribute('position', position);
        eventLine.addEventListener('click', (function (scope, line, destroyBtn, data) {
            return function (e) {

                var allowAdd = true;

                e.stopPropagation();
                e.preventDefault();
                e.stopImmediatePropagation();

                for (var i = 0, l = Monet.Session.Task.lastLinkForm.events.data.length; i < l; i++) {
                    var dataId = Monet.Session.Task.lastLinkForm.events.data[i];
                    if (data.id === dataId.id) {
                        allowAdd = false;
                    }
                }

                if (this.parentNode.getAttribute('class') === 'taskEventsSelected') {
                    return;
                }

                if (allowAdd) {
                    scope.addInSelectedEventList(line, destroyBtn, scope);
                } else {
                    new Greenmile.Components.AlertModal('TaskManager.Event.EventAlreadyInserted')
                        .show();
                }


            };
        }(this, eventLine, destroylink, data)));

        // Events
        messageBody.appendChild(document.createTextNode(data.messageBody));
        timeValuedFalse.appendChild(document.createTextNode(formattedDate));
        destroylink.className = 'table-action-destroylink';

        listLine.appendChild(messageBody);
        listLine.appendChild(timeValuedFalse);

        destroylink.appendChild(destroyHidden);

        eventLine.setAttribute('latitude', data.latitude);
        eventLine.setAttribute('longitude', data.longitude);
        eventLine.setAttribute('icon', data && data.event && data.event.icon);

        if (data.stop && data.stop.latitude && data.stop.longitude) {
            eventLine.setAttribute('stopLatitude', data.stop.latitude);
            eventLine.setAttribute('stopLongitude', data.stop.longitude);
        }

        eventLine.appendChild(listLine);
        eventLine.appendChild(destroylink);

        return eventLine;
    },

    renderFilteredEventsList: function (data) {

        var filteredList = document.querySelector('#taskManager-event .taskEventsFiltered');
        var fragment = document.createDocumentFragment();

        if (data) {

            for (var i in data) {
                fragment.appendChild(this.renderItemToEventLogList(data[i], i));
            }
        }

        filteredList.innerHTML = "";
        filteredList.appendChild(fragment);

    },

    addInSelectedEventList: function (selectedItem, destroyBtn, scope) {

        var selectedContainer = document.querySelector('.taskEventsSelected'),
            filteredList      = document.querySelector('#taskManager-event .taskEventsFiltered'),
            allFilteredEvents = filteredList.children;

        destroyBtn.addEventListener('click', (function (eventLine, container, allFilteredEvents) {
            return function (e) {

                e.stopPropagation();
                e.preventDefault();
                e.stopImmediatePropagation();

                var reattachElementToListFiltered = function () {

                    var eventLinePosition = eventLine.getAttribute('position'),
                        intLinePosition   = parseInt(eventLinePosition, 10);

                    if (allFilteredEvents.length === 0) {

                        filteredList.appendChild(eventLine);

                    } else {

                        var inserted = false;

                        for (var j = 0; j < allFilteredEvents.length; j++) {

                            var filteredEvent    = allFilteredEvents[j],
                                eventPosition    = filteredEvent.getAttribute('position'),
                                intEventPosition = parseInt(eventPosition, 10);

                            if (intLinePosition < intEventPosition) {

                                filteredList.insertBefore(eventLine, filteredEvent);
                                inserted = true;
                                break;

                            }

                        }

                        if (inserted === false) {

                            filteredList.appendChild(eventLine);

                        }

                    }
                };

                const confirmRemoveEvent = () => {

                    var idToRemove = eventLine.querySelector('.eventLogId');
                    var eventLogTaskLinked = null;
                    var indexData = null;
                    var callback = function () {
                        reattachElementToListFiltered();
                        Monet.Session.Task.lastLinkForm.events.data.splice(indexData, 1);
                        Monet.Session.Task.lastLinkForm.routes.nodes.splice(indexData, 1);
                        Monet.Session.Task.lastLinkForm.routes.ids.splice(indexData, 1);
                    };

                    Monet.Session.Task.lastLinkForm.events.data.forEach(function (element, index) {

                        if (element.eventLog.id.toString() === idToRemove.value) {
                            eventLogTaskLinked = element.id;
                            indexData = index;
                            return null;
                        }
                    });

                    if (eventLogTaskLinked) {
                        Greenmile.Task.RelatedInfo.deleteTaskLinked(eventLogTaskLinked, callback);
                    } else {
                        reattachElementToListFiltered();
                    }

                };

                Greenmile.Task.RelatedInfo.showAlertToConfirm(confirmRemoveEvent);

            };
        }(selectedItem, selectedContainer, allFilteredEvents, scope)));

        selectedContainer.appendChild(selectedItem);

    },

    addMapToEventInfo: function (data) {

        var selector = 'formLinkEventMaps_' + data.id;
        App.Views.Task.renderMaps(selector, data);
            
    }

};